import { clsx } from 'clsx'
import { Copy } from './icons'
import { initials } from './initials'

type Props = {
  name: string
  role: string
  email?: string
  photoUrl?: string
  bio?: string
  className?: string
  onCopyEmail?: (email: string) => void
}

export function TeamCard({ name, role, email, photoUrl, bio, className, onCopyEmail }: Props) {
  return (
    <article className={clsx('grid content-start gap-4', className)}>
      <div className="aspect-[4/5] w-full overflow-hidden bg-gray-100">
        {photoUrl ? (
          <img src={photoUrl} alt="" className="h-full w-full object-cover" loading="lazy" />
        ) : (
          <div className="grid h-full w-full place-items-center font-display text-h2 text-gray-400" aria-hidden="true">
            {initials(name)}
          </div>
        )}
      </div>
      <div className="grid gap-1">
        <h3 className="text-h4">{name}</h3>
        <p className="text-small text-dim">{role}</p>
        {bio && <p className="mt-1 text-small text-charcoal">{bio}</p>}
        {email && (
          // Inline, so in a narrow column the address breaks after the @ (not mid-word) and the copy button follows its last line.
          <p className="mt-1 text-[0.75rem] sm:text-small">
            <a href={`mailto:${email}`} className="underline underline-offset-4 decoration-1 hover:text-ink">
              {email.split('@')[0]}@<wbr />
              {email.split('@').slice(1).join('@')}
            </a>
            {/* The space lets the button drop to the next line, rather than the address breaking to make room for it. */}
            {onCopyEmail && ' '}
            {onCopyEmail && (
              <button
                type="button"
                onClick={() => onCopyEmail(email)}
                className="inline-flex h-7 w-7 items-center justify-center align-middle text-dim hover:text-ink"
                aria-label={`Copy ${email}`}
              >
                <Copy />
              </button>
            )}
          </p>
        )}
      </div>
    </article>
  )
}
